import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { IManageLocalization, IValidationLocalization } from "../../../models/localization";
import { ScreenMode } from "../../../models/enums";
import { Auth } from "../../../utils/auth";
import Button from "material-ui/Button";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, withMobileDialog } from "material-ui/Dialog";
import TextField from "material-ui/TextField";
import { FormControl } from "material-ui/Form";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TextValidator } from "react-material-ui-form-validator";
import Visibility from "material-ui-icons/Visibility";
import VisibilityOff from "material-ui-icons/VisibilityOff";
import IconButton from "material-ui/IconButton";
import Input, { InputLabel, InputAdornment } from "material-ui/Input";

@observer
export default class ChangePasswordDlg extends React.Component<{ store: SeekerStore }, {}> {
  @observable oldPwd: string;
  @observable showOldPwd: boolean;
  @observable newPwd: string;
  @observable showNewPwd: boolean;
  @observable confirmPwd: string;
  @observable showConfirmPwd: boolean;
  @observable errMsg: string;
  constructor(props: any) {
    super(props);
    this.oldPwd = this.newPwd = this.confirmPwd = "";
    this.showOldPwd = this.showNewPwd = this.showConfirmPwd = false;
  }
  handleSubmit = (): void => {
    const local: IManageLocalization = this.props.store.localization.fields.manage;
    Auth.changePassword(this.oldPwd, this.newPwd, this.confirmPwd, action((err: string): void => {
      if (!err) {
        this.props.store.viewState.setShowPasswordChange(false);
        this.oldPwd = this.newPwd = this.confirmPwd = this.errMsg = "";
        this.showOldPwd = this.showNewPwd = this.showConfirmPwd = false;
        this.props.store.viewState.setShowSnackbar(true, local.passwordResetMsg);
      } else {
        this.errMsg = err;     
      }
    }));
  }
  @action toggleShowOldPassword = (): void => {
    this.showOldPwd = !this.showOldPwd;
  }
  @action toggleShowNewPassword = (): void => {
    this.showNewPwd = !this.showNewPwd;
  }
  @action toggleShowConfirmPassword = (): void => {
    this.showConfirmPwd = !this.showConfirmPwd;
  }
  @action handleInputChange = (e: any): void => {
    if (e.target.value) {
      this.errMsg = "";
    }
    const key: string = e.target.name || e.target.id;
    if (key) {
      this[key] = e.target.value;
    }
  }

  render(): JSX.Element {
    const local: IManageLocalization = this.props.store.localization.fields.manage;
    const validation: IValidationLocalization = this.props.store.localization.fields.validation;
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
      if (value !== this.newPwd) {
        return false;
      }
      return true;
    });
    const styles: any = {
      MuiIconButton: {
        color: "#5B6770",
      },
      container: {
        padding: "0",
      },
    }
    return (<Dialog
      open={this.props.store.viewState.showPasswordChange}
      onClose={() => this.props.store.viewState.setShowPasswordChange(false)}
      aria-labelledby="responsive-dialog-title"
      fullScreen={this.props.store.viewState.screenMode === ScreenMode.Mobile} >
      <DialogTitle id="alert-dialog-title">{local.title}</DialogTitle>
      <ValidatorForm
        ref="form"
        instantValidate={false}
        onSubmit={this.handleSubmit}>
        <DialogContent>
          <DialogContentText id="logged-in-as">{local.loggedIn} <b>{this.props.store.profileStore.profile.demographics.emailAddress}</b></DialogContentText>
          <br />
          <TextValidator
            label={local.oldPwd}
            style={{ width: "100%" }}
            name="oldPwd"
            id="oldPwd"
            autoComplete="current-password"
            type={this.showOldPwd ? "text" : "password"}
            validators={['required']}
            errorMessages={[validation.requiredField]}
            value={this.oldPwd}
            onChange={this.handleInputChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton style={styles.MuiIconButton}
                    onClick={this.toggleShowOldPassword}
                    onMouseDown={() => (e) => event.preventDefault()}>
                    {this.showOldPwd ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }} />
          <br />
          <br />
          <TextValidator
            label={local.newPwd}
            style={{ width: "100%" }}
            name="newPwd"
            id="newPwd"
            autoComplete="current-password"
            type={this.showNewPwd ? "text" : "password"}
            validators={['required']}
            errorMessages={[validation.requiredField]}
            value={this.newPwd}
            onChange={this.handleInputChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton style={styles.MuiIconButton}
                    onClick={this.toggleShowNewPassword}
                    onMouseDown={() => (e) => event.preventDefault()}>
                    {this.showNewPwd ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }} />
          <br />
          <br />
          <TextValidator
            label={local.confirmPwd}
            style={{ width: "100%" }}
            name="confirmPwd"
            id="confirmPwd"
            autoComplete="current-password"
            type={this.showConfirmPwd ? "text" : "password"}
            validators={['required', 'isPasswordMatch']}
            errorMessages={[validation.requiredField, 'Passwords do not match']}
            value={this.confirmPwd}
            onChange={this.handleInputChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton style={styles.MuiIconButton}
                    onClick={this.toggleShowConfirmPassword}
                    onMouseDown={() => (e) => event.preventDefault()}>
                    {this.showConfirmPwd ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }} />
          <br />
          <DialogContentText style={{ color: "red" }}>{this.errMsg}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => this.props.store.viewState.setShowPasswordChange(false)}
            color="secondary">
            {local.close}
          </Button>
          <Button
            type="submit"
            color="secondary"
            disabled={this.newPwd.length === 0 || this.newPwd !== this.confirmPwd}
            autoFocus>
            {local.changePwdBtn}
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>);
  }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/passwordChange/index.tsx